import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { idFromPrefix } from '@@client/lib/forms';
import { classnames } from '@@client/lib/classes';
import FormField from '@@client/components/FormField';

var OneOption = function OneOption(_ref) {
  var _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'checkbox' : _ref$kind,
      name = _ref.name,
      id = _ref.id,
      errorId = _ref.errorId,
      label = _ref.label,
      value = _ref.value,
      isChecked = _ref.isChecked,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return /*#__PURE__*/_jsxs("div", {
    className: "field-checkbox-item",
    children: [/*#__PURE__*/_jsx("input", {
      type: kind,
      id: id,
      name: name,
      value: value,
      checked: isChecked,
      onChange: onChange,
      disabled: disabled ? 'disabled' : '',
      "aria-describedby": errorId
    }), /*#__PURE__*/_jsx("label", {
      htmlFor: id,
      children: label
    })]
  });
};

export default function FormCheckboxList(_ref2) {
  var idPrefix = _ref2.idPrefix,
      name = _ref2.name,
      onChange = _ref2.onChange,
      className = _ref2.className,
      selectedValue = _ref2.selectedValue,
      options = _ref2.options,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$kind = _ref2.kind,
      kind = _ref2$kind === void 0 ? 'checkbox' : _ref2$kind,
      formFieldAtts = _objectWithoutProperties(_ref2, ["idPrefix", "name", "onChange", "className", "selectedValue", "options", "disabled", "kind"]);

  var id = idFromPrefix(idPrefix, name);
  var errorId = idPrefix + '--error';
  var classNames = classnames(['field-checkbox-list', className]);
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    errorId: errorId,
    className: classNames
  }, formFieldAtts), {}, {
    children: options.map(function (info, i) {
      return /*#__PURE__*/_jsx(OneOption, {
        id: id + '--' + i,
        kind: kind,
        isChecked: selectedValue === info.value,
        name: name,
        label: info.label,
        value: info.value,
        disabled: disabled,
        errorId: errorId,
        onChange: onChange
      }, info.value);
    })
  }));
}